function tryParseJSON(value) {
  if (typeof value !== "string") return value;

  const trimmed = value.trim();

  //check to avoid parsing normal strings
  if (!((trimmed.startsWith("{") && trimmed.endsWith("}")) || (trimmed.startsWith("[") && trimmed.endsWith("]")))) {
    return value;
  }

  try {
    return JSON.parse(trimmed);
  } catch {
    return value;
  }
}

function deepUnwrapJSON(value) {
  let current = value;
  let previous;

  // Unwrap multiple encoding layers
  do {
    previous = current;
    current = tryParseJSON(current);
  } while (current !== previous);

  // Recursively process objects & arrays
  if (Array.isArray(current)) {
    return current.map(deepUnwrapJSON);
  }

  if (current && typeof current === "object") {
    const result = {};
    for (const key in current) {
      result[key] = deepUnwrapJSON(current[key]);
    }
    return result;
  }

  return current;
}

export function formatMessagePayload(messages, indent = 2) {
  if (messages == null) return "";

  let payload = deepUnwrapJSON(messages);

  try {
    return JSON.stringify(payload, null, indent);
  } catch {
    return String(messages);
  }
}
